module.exports = __webpack_public_path__ + "static/limelight-20e7ac9afb2428ba6c72425786ee9ee6.svg";